import React, { useEffect } from 'react'
import {
  Button, TextField, Grid,
  IconButton, FormGroup, FormControlLabel,
  Checkbox,
} from '@material-ui/core'
import {
  withStyles, makeStyles,
} from '@material-ui/core/styles'
import { useFormik } from 'formik'
// import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { orange } from '@material-ui/core/colors'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Page from 'src/components/Page'
import styles from './Basket.module.css'
import BasketIcon from '../../../icons/BasketIcon'
import {
  getCourseBasket, selectorCourseBasket,
  deleteCourseBasket, checkBasketDiscount,
  payCourseBasket, selectorBaskeDiscountPrice,
} from '../../../app/slices/courseSlice'
import { thousandSeperator } from '../../../utils/getInitials'
import DeleteIcon from '../../../icons/DeleteIcon'
import mellat from '../../../assets/img/mellat.png'
import saman from '../../../assets/img/saman.png'

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '50px',
      height: '55px',
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(TextField)

const OrangeCheckbox = withStyles({
  root: {
    color: orange[400],
    '&$checked': {
      color: orange[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />)

const bankPortals = [
  {
    name: 'mellat',
    desc: 'bank_mellat_payment_gateway',
    url: mellat,
  },
  {
    name: 'saman',
    desc: 'bank_saman_payment_gateway',
    url: saman,
  },
]

const useStyles = makeStyles((theme) => ({
  root: {
  },
  discountBtn: {
    backgroundColor: '#e6332a',
    width: '150px',
    height: '40px',
    borderRadius: '20px',
    color: '#fff',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    display: 'flex',
    margin: '0 auto',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
    '@media (max-width: 960px)': {
      alignItems: 'end',
      margin: '0',
      float: 'right',
    },

  },
  discountBtnWrap: {
    '@media (max-width: 1360px)': {
      marginLeft: '10px',
    },
  },
  totalBtn: {
    backgroundColor: '#e6332a',
    width: '150px',
    height: '40px',
    borderRadius: '20px',
    color: '#fff',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    display: 'flex',
    marginLeft: '20px ',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
  deleteAllBtn: {
    backgroundColor: '#e6332a',
    width: '150px',
    height: '40px',
    borderRadius: '20px',
    color: '#fff',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    display: 'flex',
    marginLeft: '20px ',
    marginBottom: '20px',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    cursor: 'pointer',
    '&:hover': {
      color: '#f39994',
    },
  },
  bankGroup: {
    margin: '30px auto 0',
    display: 'flex',
    justifyContent: 'center',
    // alignItems: 'center',
  },
  portal: {
    marginBottom: theme.spacing(2),
  },
  portalLabel: {
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.spacing(1.5),
    },
  },
  bankImage: {
    width: theme.spacing(9.1),
    height: theme.spacing(7.7),
    verticalAlign: 'middle',
    marginLeft: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(6.1),
      height: theme.spacing(4.7),
    },
  },
}))

const Basket = () => {
  const classes = useStyles()
  const courseBasket = useSelector(selectorCourseBasket)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const discountPrice = useSelector(selectorBaskeDiscountPrice)

  useEffect(() => {
    dispatch(getCourseBasket())
  }, [])

  const formik = useFormik({
    initialValues: {
      username: '',
      phoneNumber: '',
      address: '',
      postalCode: '',
      discount: '',
      selectedAddress: '',
    },
    enableReinitialize: true,
    onSubmit: (fields) => {
      const { portal, discount } = fields
      const ipg = bankPortals.findIndex((bank) => bank.name === portal) + 1
      const discountcode = discount || undefined
      const callBackUrl = `${window.location.origin}/BankResult`

      if (ipg) {
        dispatch(payCourseBasket({ ipg, callBackUrl, discountcode }, navigate))
      }
    },

  })

  const allId = courseBasket?.items?.map((item) => item?.id)

  console.log(allId)

  const checkDiscount = () => {
    dispatch(checkBasketDiscount(formik.values.discount))
    console.log(formik.values.discount)

    console.log(discountPrice)
  }

  let finalPrice = courseBasket?.totalPrice

  if (discountPrice) {
    finalPrice = discountPrice
  } else {
    finalPrice = courseBasket?.totalPrice
  }

  return (
    <Page
      title="سبد خرید"
      className={styles.basketWrap}
    >
      <div
        className={styles.basketHeaderWrap}
      >
        <div
          className={styles.basketHeaderIconWrap}
        >
          <span>
            <BasketIcon />
          </span>
          <span
            className={styles.basketHeaderIconText}
          >
            سبد خرید
          </span>
        </div>
        <span
          className={styles.basketHeaderDesc}
        >
          مجموع آموزش های تخصصی مورد نظر با موفقیت به سبد خرید افزوده شد
        </span>
      </div>

      <div
        className={styles.basketBody}
      >
        <div
          className={styles.basketBodyFinalText}
        >
          نهایی کردن خرید
        </div>
        <div>
          <table
            className={styles.basketTable}
          >
            <thead>
              <tr>
                <th>ردیف</th>
                <th>نام دوره</th>
                <th style={{ textAlign: 'center' }}>حذف</th>
              </tr>
            </thead>
            <tbody>
              {courseBasket?.items?.map((basket, i) => (
                <tr
                  key={basket?.id}
                >
                  <td>{i + 1}</td>
                  <td>{basket?.courseGroup?.title}</td>

                  <td
                    style={{ textAlign: 'center' }}
                  >
                    <IconButton
                      onClick={() => dispatch(deleteCourseBasket([basket?.id]))}
                    >
                      <DeleteIcon
                        className={classes.icons}
                      />

                    </IconButton>
                  </td>
                </tr>
              ))}
              <tr>
                <td>مجموع</td>
                <td>
                  {thousandSeperator(courseBasket?.totalPrice)}
                  {' '}
                  تومان
                </td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'end' }}
        >
          <Button
            className={classes.deleteAllBtn}
            onClick={() => dispatch(deleteCourseBasket(allId))}
          >
            حذف همه دوره ها
          </Button>
        </div>
        <div
          className={styles.basketBodyDesc}
        >
          پس از نهایی شدن فرایند ثبت سفارش به بخش دوره‌های خریداری
          شده مراجعه و دوره‌های خود را مشاهده کنید.
        </div>
      </div>
      <form
        onSubmit={formik.handleSubmit}
      >
        <div
          className={styles.basketDiscount}
        >
          <span
            className={styles.basketDiscountTitle}
          >
            کد تخفیف دارید؟

          </span>
          <Grid
            container
            xs={12}
            className={styles.basketDiscountWrap}
          >
            <Grid
              item
              md={6}
              xs={12}
            >

              <CssTextField
                error={Boolean(formik.touched.discount && formik.errors.discount)}
                fullWidth
                helperText={formik.touched.discount && formik.errors.discount}
                label="کد تخفیف"
                margin="normal"
                name="discount"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.discount}
                variant="outlined"
              />

            </Grid>

            <Grid
              item
              md={2}
              xs={12}
              className={classes.discountBtnWrap}
            >
              <Button
                className={classes.discountBtn}
                onClick={checkDiscount}
              >
                اعمال تخفیف
              </Button>
            </Grid>

            <div style={{
              width: '100%',
              margin: '20px 0',
              display: 'flex',
              alignItems: 'center',
              flexFlow: 'row',
            }}
            >
              {discountPrice || discountPrice === 0 ? (
                <>
                  <p style={{
                    width: '30%',
                  }}
                  >
                    کد تخفیف شما:
                    {' '}
                    {formik.values.discount}
                  </p>
                </>
              ) : null}
              {discountPrice || discountPrice === 0 ? (
                <h4
                  style={{
                    width: '30%',
                    color: 'green',
                  }}
                >
                  {discountPrice !== 0 ? `${t('fee_payable')}: ${discountPrice
                    ? thousandSeperator(discountPrice ?? 0) : thousandSeperator(450)} ${t('rials')}` : 'رایگان'}
                </h4>
              ) : null}

            </div>

            <Grid
              xs={12}
            >

              <FormGroup classes={{ root: classes.bankGroup }}>
                {
bankPortals?.map((portal, i) => (
  <FormControlLabel
    classes={{ root: classes.portal, label: classes.portalLabel }}
    key={i}
    control={(
      <OrangeCheckbox
        checked={formik.values.portal === portal.name}
        onChange={() => formik.setFieldValue('portal', portal.name)}
        name={portal.name}
      />
)}
    label={(
      <>
        {t(portal.desc)}
        <img src={portal.url} alt={portal.name} className={classes.bankImage} />
      </>
)}
  />
))
}
              </FormGroup>
            </Grid>

          </Grid>

        </div>
        <div
          className={styles.basketTotal}
        >
          <span
            className={styles.basketTotalPrice}
          >
            مبلِغ قابل پرداخت:
            {' '}
            {thousandSeperator(finalPrice)}
          </span>

          <Button
            type="submit"
            className={classes.totalBtn}
          >
            پرداخت
          </Button>
        </div>
      </form>
    </Page>
  )
}

export default React.memo(Basket)
